// extracted by mini-css-extract-plugin
export var container = "_g5-0";
export var content = "_g5-3";
export var customerTitle = "_g5-4";
export var empty = "_g5-5";
export var gray = "_g5-6";
export var header = "_g5-7";
export var info = "_g5-8";
export var loading = "_g5-2";
export var loadingCard = "_g5-9";
export var oneLine = "_g5-a";
export var personName = "_g5-e";
export var pillContainer = "_g5-b";
export var selected = "_g5-1";
export var text = "_g5-c";
export var twoLines = "_g5-d";
export var unread = "_g5-f";
export var unreadIndicator = "_g5-g";